import type { ComponentType, ReactElement, ReactNode } from 'react'
import { isValidElement } from 'react'

import type { css } from '@emotion/react'
import { jsx } from '@emotion/react'
import { isNil } from 'ramda'

import { cloneElement } from './react'

type Interpolation = ReturnType<typeof css>

type CssClassesApi = {
  styles?: { [key: string]: string }
  className?: string
  css?: Interpolation
}

export const normalizeReactNode = (
  node?: ReactNode,
  props: { [propName: string]: unknown } = {},
  wrapper: keyof JSX.IntrinsicElements | ComponentType = 'span'
) => {
  if (isNil(node)) {
    return null
  }

  if (!isValidElement(node)) {
    return jsx(wrapper, props, node)
  }

  const { className: classNameProp, ...otherProps } = props as CssClassesApi
  const { className: nodeClassName } = node.props as CssClassesApi &
    Partial<{
      className: string
    }>

  if (classNameProp !== undefined) {
    return cloneElement(node as ReactElement, {
      ...otherProps,
      className: `${
        nodeClassName !== undefined ? `${nodeClassName} ` : ''
      }${classNameProp}`,
    })
  }

  return cloneElement(node as ReactElement, props)
}
